<div class="dialog-content single-action-dialog">
  <!--title 標題-->
  <h1 class="dialog-title">
    @if (needsPagination) {
      @for(group of data.groups; track $index) {
        @if ($index === currentGroupIndex) {
          以下項目 {{ getChineseTitle() }}
        }
      }
    } @else {
      以下項目 {{ getChineseTitle() }}
    }
  </h1>
  <!--btn:關閉按鈕-->
  <button mat-button (click)="closeDialog()" class="dialog-close-btn">
    <img src="assets/img/i-close.svg" alt="" />
  </button>
  <div mat-dialog-content>
    @if (isMultipleChoice) {
      <!-- 多選模式 -->
      <div class="input-block">
        @for (item of itemList; track $index) {
          <mat-checkbox 
            class="input-checkbox" 
            [checked]="isSelected($index)"
            [disabled]="!isSelected($index) && selectedGroupIndexes.length >= currentGroup.chooseCount"
            (change)="onCheckboxChange($event.checked, item, $index)">
            <div class="group-option">
              @for (examItem of item.examItemList; track examItem.examItem) {
                <div class="exam-item">{{ examItem.examName }}</div>
              }
            </div>
          </mat-checkbox>
        }
      </div>
    } @else {
      <!-- 單選模式 -->
      <mat-radio-group class="input-block" [value]="selectedGroupIndex" (change)="onRadioChange($event.value)">
        @for (item of itemList; track $index) {
          <mat-radio-button [value]="$index" class="input-radio">
            <div class="group-option">
              @for (examItem of item.examItemList; track examItem.examItem) {
                <div class="exam-item">{{ examItem.examName }}</div>
              }
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  </div>

  @if (needsPagination) {
    <!-- 分頁按鈕 -->
    <div class="dialog-btn-block">
      @if (currentGroupIndex > 0) {
        <button
          mat-button
          class="btn-outline-primary btn-size-M"
          (click)="previous()"
          [disabled]="!canPrevious"
        >
          {{ 'common.button.previous' | translate }}
        </button>
      }
      <button
        mat-button
        class="btn-fill-primary btn-size-M"
        (click)="next()"
        [disabled]="!canNext"
      >
        {{ currentGroupIndex === totalGroups - 1 ? ('common.button.positive' | translate) : ('common.button.next' | translate) }}
      </button>
    </div>
  } @else {
    <button
    mat-button
    class="btn-fill-primary btn-size-l"
    (click)="confirm()"
    [disabled]="!canConfirm"
  >
    {{ 'common.button.positive' | translate }}
  </button>
  }
</div>
